export class StringUtils {
  public static trim(input: string): string {
    return input ? String.prototype.trim.call(input) : '';
  }

  /**
   * Generate GUID string compliant to RFC4122 v4 standard
   * return string - GUID string
   */
  public static uuid(): string {
    // Define function to generate 4 random characters
    const s4 = () => {
      const randomNum = (1 + Math.random()) * 0x10000;
      const randomStr = Math.floor(randomNum).toString(16).substring(1);

      return randomStr;
    };

    // Create several sections of variable length
    const rows = [
      s4() + s4(),
      s4(),
      s4(),
      s4(),
      s4() + s4() + s4()
    ];

    // Join the sections into a string separated by '-' and return
    return rows.join('-');
  }

  public static capitalize(s): string {
    if (typeof s !== 'string') {
      return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  public static isUndefinedNullOrEmpty(s: any): boolean {
    if (s === null || s === undefined) {
      return true;
    }

    if (typeof s !== 'string') {
      return false;
    }

    return s === '';
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/string.utils.ts